import React from "react";
import { useEffect, useState, useRef } from "react";
import Storage from "@/app/core/util/Storage";
import { UserStatusObj, UserTypeObj } from "@/app/core/util/helpers/UserHelper";
import CreditCardModal from "@/app/core/layouts/main-components/charge/CreditCardModal";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { CardsController } from "@/app/core/base/controllers/CardsController";
import { toast } from "react-toastify";
import { InvoiceController } from "@/app/core/base/controllers/InvoiceController";
import { DateTranslate, OnlyDateTranslate } from "@/app/core/util/DateTranslater";
import { MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { PaymentHelper } from "@/app/core/util/helpers/PaymentHelper";
import InvoiceModal from "@/app/core/layouts/main-components/charge/InvoiceModal";

export default function ChargingComponent() {
    const userData = Storage.getUserData();
    const [selected, setSelected] = useState({});
    const [cards, setCards] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);

    useEffect(() => {
        loadCards()
        loadInvoices()
    }, []);

    async function loadInvoices() {
        await InvoiceController.Get(userData.id, res => {
            setInvoices(res);
        })
    }

    async function loadCards() {
        await CardsController.List(res => {
            setCards(res);
        })
    }


    async function removeCard(item) {
        if (window.confirm(Translate(Message.DeleteConfirm))) {
            CardsController.Delete(item.id, res => {
                toast.success(Message.DeleteSuccess);
                setTimeout(() => {
                    loadCards();
                }, 400);
            })
        }
    }

    function closeInvoice() {
        const date = new Date();
        let base = {};//InvoiceController.BaseModel;
        base.userId = userData.id;
        base.month = date.getMonth() - 1;
        base.year = date.getFullYear();

        InvoiceController.Insert(base, res => {
            toast.success(Translate(Message.Saved));
            loadInvoices();
        });
    }


    function openInvoice(item) {
        setSelected(item);
        setShowInvoiceModal(true)
    }

    return (
        <div className="content row mt-3">
            <div className="col-md-12">
                <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> {Translate(Message.Menu.Billing)}</h3>
            </div>
            {/* {userData && userData.type == UserTypeObj.LegalPerson ?
                ""
                : */}
            <div className="col-12 row">
                <div className="col-md-8">
                    <h2 className="content-heading font-w700">{Translate(Message.Payment.Cards)}</h2>
                </div>
                <div className="col-md-4 text-right">
                    <button className="btn btn-success" onClick={() => setShowModal(true)}>
                        <i className="si si-plus" /> {Translate(Message.Payment.AddCard)}
                    </button>

                    {/* {userData.companyId != null && userData.companyId != undefined ?
                            : ""} */}
                </div>
                <div className="col-md-12">
                    <table className="table table-hover table-striped">
                        <thead>
                            <tr>
                                <th>{Translate(Message.Payment.CardNumber)}</th>
                                <th>{Translate(Message.Payment.Brand)}</th>
                                <th>{Translate(Message.Payment.Expiration)}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {cards &&
                                cards.map((item, index) => (
                                    <tr>
                                        <td>**** {item.lastFourDigits}</td>
                                        <td>{item.brand}</td>
                                        <td>{item.expMonth}/{item.expYear}</td>
                                        <td>
                                            <button className="btn btn-dual btn-sm" onClick={() => removeCard(item)}>
                                                <i className="si si-trash text-danger" /> {Translate(Message.Delete)}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    {cards.length === 0 ? (
                        <div className="col-12 text-center">
                            {/* <h4 className="font-w700 text-dark">Nenhum cartão adicionado</h4> */}
                            <a
                                className="btn btn-info"
                                href="javascript:void(0)"
                                onClick={() => setShowModal(true)}
                            >
                                {Translate(Message.Payment.AddCard)}
                            </a>
                            <hr style={{ width: 60 }} />
                        </div>
                    ) : (
                        ""
                    )}

                </div>
            </div>
            {/* } */}
            <div className="col-md-6">
                <h2 className="content-heading font-w700">{Translate(Message.Invoices)}</h2>
            </div>
            <div className="col-md-6 text-right">
                <button className="btn btn-success" onClick={() => closeInvoice()}>
                    <i className="si si-check" /> Fechar fatura
                </button>
            </div>
            <div className="col-md-12">
                <table className="table table-hover table-striped">
                    <thead>
                        <tr>
                            <th>{Translate(Message.DueDate)}</th>
                            <th>{Translate(Message.BillingPeriod)}</th>
                            <th>{Translate(Message.Delivery.Delivery)}</th>
                            <th>{Translate(Message.Value)}</th>
                            {/* <th>{Translate(Message.Value)}</th> */}
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices && invoices.map(item => (
                            <tr>
                                <th>{DateTranslate(item.dueAt)}</th>
                                <th>{OnlyDateTranslate(item.start)} - {OnlyDateTranslate(item.end)}</th>
                                <th>{item.deliveries}</th>
                                <th>R${MoneyMask(item.paymentAmount, 2)}</th>
                                {/* <th>R${MoneyMask(item.paymentAmount, 2)}</th> */}
                                <th>{PaymentHelper.InvoiceTranslate(item.paymentStatus)}</th>
                                <th>
                                    <button className="btn btn-dual btn-sm" onClick={() => openInvoice(item)}>
                                        <i className="far fa-eye" /> {Translate(Message.ViewInvoice)}
                                    </button>
                                </th>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {invoices && invoices.length == 0 ?
                    <div>
                        {userData && userData.type == UserTypeObj.LegalPerson && userData.status == UserStatusObj.Active ?
                            <div className="col-12 text-center">
                                <h4 className="font-w700 text-dark">{Translate(Message.BillingEnabled)}</h4>
                                <p className="font-w700 text-dark"></p>
                                <hr style={{ width: 60 }} />
                            </div>
                            :
                            <div className="col-12 text-center">
                                <h4 className="font-w700 text-dark">{Translate(Message.BillingDisabled)}</h4>
                                <p className="font-w700 text-dark"></p>
                                <hr style={{ width: 60 }} />
                            </div>
                        }
                    </div>
                    : ""}
            </div>
            <CreditCardModal
                show={showModal}
                onHide={() => setShowModal(false) | loadCards()}
            />
            <InvoiceModal
                show={showInvoiceModal}
                invoice={selected}
                onHide={() => setShowInvoiceModal(false) | loadInvoices() | setSelected({})}
            />
        </div>
    )
}